import VistaprintAuth from '@vp/auth';

const getShopperInfo = () => {
  try {
    const auth = new (VistaprintAuth.WebAuth ?? VistaprintAuth.default.WebAuth)();
    return {
      authorization: auth.getAuthorizationHeader(),
      shopperId: auth.getCanonicalId()
    };
  } catch (ex) {
    return {};
  }
};
const isValidShopperInfo = function(shopperInfo) {
  return !!(shopperInfo && shopperInfo.shopperId && shopperInfo.authorization);
};

export { getShopperInfo, isValidShopperInfo };
//# sourceMappingURL=web-shopper.js.map
